import { PCIDSS_MAPPING, PCIDSS_HOSTS_MAPPING } from '@/features/pcidss/mapping';
import { IRequestConfig } from '@/features/pcidss/store/pcidss.types';

export function getPCIDSSHostMapping(host: string) {
  return Object.keys(PCIDSS_HOSTS_MAPPING).reduce((prev, current) => {
    return PCIDSS_HOSTS_MAPPING[current] ? prev.replace(current, PCIDSS_HOSTS_MAPPING[current]) : prev;
  }, host);
}

export function getPCIDSSMapping(originalRequest: IRequestConfig): IRequestConfig {
  const body = originalRequest.method === 'GET' ? new URLSearchParams(originalRequest.search) : originalRequest.body;
  const key = `${originalRequest.method}-${originalRequest.pathname}`;

  if (!!PCIDSS_MAPPING[key]) {
    return {
      ...originalRequest,
      ...PCIDSS_MAPPING[key](originalRequest.baseURL, body),
    };
  }
  return originalRequest;
}
